import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { updateConfig } from "../../../../store/slices/User/UserDetails/profileActivityLogSlice";
import { updateConfig as globalUpdateConfig } from "../../../../store/slices/Global";
import { useGetProfileActivityLogDataQuery, useUpdateProfileActivityLogTableHeadDataMutation } from "../../../../store/queries/User";

const useProfileActivityLog = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const activeProfile = user_id ?? sessionStorage.getItem("active");
  const profileActivityLogState = useSelector((state) => state.profileActivityLog);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const {
    data: profileActivityLog = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetProfileActivityLogDataQuery({
    user_id: activeProfile,
    page_size: profileActivityLogState?.currentPageSize,
    page: profileActivityLogState?.currentPage,
    sort: profileActivityLogState?.sortBy,
    sort_order: profileActivityLogState?.sortOrder,
    search: profileActivityLogState?.search,
  });
  const [updateProfileActivityLogFields] =
  useUpdateProfileActivityLogTableHeadDataMutation();

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (profileActivityLogState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            profileActivityLogState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  return {
    isLoading,
    isFetching,
    tableFields,
    profileActivityLog,
    showEditModal,
    profileActivityLogState,
    paginationOptions,
    updateProfileActivityLogFields,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  };
};

export default useProfileActivityLog;
